import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import api from '../Axios/axios';
import './CompanyEdit.scss';

const emptyForm = {
  id: '',
  hasTowerCrane: false,
  rentTowerCrane: false,
  name: '',
  email: '',
  address: '',
  taxNo: '',
  authorizedPerson1: '',
  phoneNumber1: '',
  authorizedPerson2: '',
  phoneNumber2: '',
  bankReceiver1: '',
  bankName1: '',
  iban1: '',
  bankReceiver2: '',
  bankName2: '',
  iban2: '',
};

const CompanyEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(emptyForm);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await api.get(`/Company/GetById?id=${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const companyData = response?.data?.data;
        if (companyData) {
          setFormData((prev) => ({
            ...prev,
            id: companyData.id || '',
            hasTowerCrane: Boolean(companyData.hasTowerCrane),
            rentTowerCrane: Boolean(companyData.rentTowerCrane),
            name: companyData.name || '',
            email: companyData.email || '',
            address: companyData.address || '',
            taxNo: companyData.taxNo || '',
            authorizedPerson1: companyData.authorizedPerson1 || '',
            phoneNumber1: companyData.phoneNumber1 || '',
            authorizedPerson2: companyData.authorizedPerson2 || '',
            phoneNumber2: companyData.phoneNumber2 || '',
          }));
        }
      } catch (error) {
        console.error('Sirket bilgileri yuklenemedi:', error);
        setErrorMessage('Sirket bilgileri yuklenemedi. Lutfen tekrar deneyin.');
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');
      const payload = {
        ...formData,
        isRentingMachineCompany: formData.hasTowerCrane,
      };
      const response = await api.put('/Company', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log('Guncelleme yaniti:', response.data);
      setSuccessMessage('Sirket bilgileri basariyla guncellendi.');
      setErrorMessage('');
      navigate('/company-list');
    } catch (error) {
      console.error('Sirket bilgileri guncellenemedi:', error);
      setErrorMessage('Sirket bilgileri guncellenemedi. Lutfen tekrar deneyin.');
      setSuccessMessage('');
    }
  };

  if (loading) {
    return <p>Yukleniyor...</p>;
  }

  return (
    <div className="company-edit-page">
      <Navbar />
      <div className="form-wrapper">
        <h2>Sirket Duzenle</h2>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Sirket Adi"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Sirket E-posta"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Sirket Adresi"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="taxNo"
                value={formData.taxNo}
                onChange={handleInputChange}
                placeholder="Vergi No"
                required
              />
            </div>
          </div>

          <div className="form-row checkbox-group">
            <div className="form-group">
              <label>Kule Vinci Var mi?</label>
              <input
                type="checkbox"
                name="hasTowerCrane"
                checked={formData.hasTowerCrane}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label>Kule Vinci Kiraliyor mu?</label>
              <input
                type="checkbox"
                name="rentTowerCrane"
                checked={formData.rentTowerCrane}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="authorizedPerson1"
                value={formData.authorizedPerson1}
                onChange={handleInputChange}
                placeholder="Yetkili Kisi 1"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phoneNumber1"
                value={formData.phoneNumber1}
                onChange={handleInputChange}
                placeholder="Iletisim No 1"
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="authorizedPerson2"
                value={formData.authorizedPerson2}
                onChange={handleInputChange}
                placeholder="Yetkili Kisi 2"
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phoneNumber2"
                value={formData.phoneNumber2}
                onChange={handleInputChange}
                placeholder="Iletisim No 2"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="bankReceiver1"
                value={formData.bankReceiver1}
                onChange={handleInputChange}
                placeholder="Banka Alici Adi 1"
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="bankName1"
                value={formData.bankName1}
                onChange={handleInputChange}
                placeholder="Banka Adi 1"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="iban1"
                value={formData.iban1}
                onChange={handleInputChange}
                placeholder="IBAN 1"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="bankReceiver2"
                value={formData.bankReceiver2}
                onChange={handleInputChange}
                placeholder="Banka Alici Adi 2"
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="bankName2"
                value={formData.bankName2}
                onChange={handleInputChange}
                placeholder="Banka Adi 2"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="iban2"
                value={formData.iban2}
                onChange={handleInputChange}
                placeholder="IBAN 2"
              />
            </div>
          </div>

          <button type="submit">Guncelle</button>
        </form>
      </div>
    </div>
  );
};

export default CompanyEdit;
